import PropTypes from 'prop-types';
import { useRef, useReducer, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import postParentLead from '@actions/cbseClass';
import {
  K12_LANDING_OTP_VERIFIED,
  K12_LANDING_PAGE_ACTIVITY_CONFIRMED
} from '@constants/segment';
import { useSelectorToStore } from '@hooks/reduxHooks';
import { segment } from '@actions/analytics';
import { getTopologyOnboardingGoals } from '@selectors/topologies';
import LeadGenCover from './LeadGenCover';
import SuccessFul from './SuccessFul';
import reducer from './reducer';
import BookAClass from './Class';
import BottomSheet from '../BookAClass/BottomSheet';
import ClassBooked from './ClassBooked';
import { OuterContainer, Container } from './styles';

const LeadGen = ({ apiResponse, utmParams }) => {
  const { heroForm, features, featuresBg, heroContent, success } = apiResponse;
  const { btnText } = heroForm;
  const scrollRef = useRef();
  const onboardingGoals = useSelectorToStore(getTopologyOnboardingGoals);
  const segregateGoalGroupsData = useCallback((goals) => {
    const goalGroups = [];
    goals.forEach((item) => {
      if (item.uid && item.children && item.children.length > 0) {
        if (item.children[0].children.length === 0) {
          goalGroups.push(item);
          return;
        }
        // check for k12 only goals
        return item.children.forEach((goalGroup) => {
          const k12Goals = goalGroup.children.filter(
            (goal) => goal?.category_info?.show_in_k12_category
          );
          if (k12Goals.length) {
            goalGroups.push({ ...goalGroup, children: k12Goals });
          }
        });
      }
    });
    return goalGroups;
  }, []);

  const goalGroups = onboardingGoals?.results
    ? segregateGoalGroupsData(onboardingGoals.results)
    : null;

  const K12GoalData =
    goalGroups.filter((goalGroup) => goalGroup.is_k12_goal) || [];
  const K12Goals =
    K12GoalData.length && K12GoalData[0].children
      ? K12GoalData[0].children
      : [];
  const [state, dispatch] = useReducer(reducer, {
    name: '',
    email: '',
    phoneNumber: '',
    goal_uid: '',
    selectedClass: '',
    errors: {},
    form: 'BOOK_FORM',
    open: false
  });
  const getGoalName = (goal_uid) => {
    const filteredGoal = K12Goals.find((goal) => goal.uid === goal_uid) || [];
    const goalName = filteredGoal?.name ? filteredGoal.name : '';
    return goalName;
  };
  const dispatchFn = useDispatch();
  const { form, open } = state;
  const handleSourceLogin = (response) => {
    if (response.error?.error_code === 'E132') {
      dispatch({
        type: 'SET_ERRORS',
        payload: { email: response.error.message }
      });
      dispatch({ type: 'SET_FORM', payload: 'BOOK_FORM' });
      return;
    }
    if (response.error?.error_code) return;
    dispatchFn(
      postParentLead({
        name: state.name,
        goal_uid: state.goal_uid,
        ...utmParams
      })
    ).then((res) => {
      const { name, email, phoneNumber, goal_uid, selectedClass } = state;
      const goalName = getGoalName(goal_uid);
      const data = {
        name,
        email,
        phoneNumber,
        goal_uid,
        class: selectedClass,
        activity_type: btnText,
        goal_name: goalName
      };
      if (res.type === 'PARENT_LEAD_SUCCESS') {
        segment.track(K12_LANDING_OTP_VERIFIED, data);
      }
      dispatch({ type: 'SET_FORM', payload: 'SUCCESSFUL' });
    });
  };
  useEffect(() => {
    sessionStorage.clear('bookedClass');
  }, []);
  useEffect(() => {
    if (form === 'SUCCESSFUL') {
      const { goal_uid } = state;
      const goalName = getGoalName(goal_uid);
      segment.track(K12_LANDING_PAGE_ACTIVITY_CONFIRMED, {
        goal_uid,
        activity_type: btnText,
        goal_name: goalName
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);
  return (
    <>
      <OuterContainer>
        <Container>
          <LeadGenCover
            scrollRef={scrollRef}
            heroContent={heroContent}
            form={form}
            features={features}
            featuresBg={featuresBg}
          >
            {form === 'SUCCESSFUL' ? (
              <SuccessFul
                getGoalName={getGoalName}
                success={success}
                type="leadGen"
                activityType={btnText}
                state={state}
              />
            ) : (
              <BookAClass
                getGoalName={getGoalName}
                handleSourceLogin={handleSourceLogin}
                state={state}
                dispatch={dispatch}
                heroForm={heroForm}
              />
            )}
            {form === 'CLASS_BOOKED' ? (
              <BottomSheet open={open}>
                <ClassBooked
                  phoneNumber={state.phoneNumber}
                  handleClick={() => {
                    dispatch({ type: 'TOGGLE_BOOKED_CLASS', payload: false });
                  }}
                />
              </BottomSheet>
            ) : null}
          </LeadGenCover>
        </Container>
      </OuterContainer>
    </>
  );
};

LeadGen.propTypes = {
  apiResponse: PropTypes.objectOf(PropTypes.any).isRequired
};

LeadGen.defaultProps = {};

export default LeadGen;
